import React from 'react';

export const Sizes = () => {
    return (
        <>
            <div className="size-examples-list">
                <div>
                    <p className="item-label">
                        Size half (4px)<code>$size-half</code>
                    </p>
                    <div className="size-example size-half"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size one (8px)<code>$size-1</code>
                    </p>
                    <div className="size-example size-1"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size two (16px)<code>$size-2</code>
                    </p>
                    <div className="size-example size-2"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size three (24px)<code>$size-3</code>
                    </p>
                    <div className="size-example size-3"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size four (32px)<code>$size-4</code>
                    </p>
                    <div className="size-example size-4"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size five (40px)<code>$size-5</code>
                    </p>
                    <div className="size-example size-5"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size six (48px)<code>$size-6</code>
                    </p>
                    <div className="size-example size-6"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size seven (48px)<code>$size-7</code>
                    </p>
                    <div className="size-example size-7"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size eight (64px)<code>$size-8</code>
                    </p>
                    <div className="size-example size-8"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size nine (96px)<code>$size-9</code>
                    </p>
                    <div className="size-example size-9"></div>
                </div>

                <div>
                    <p className="item-label">
                        Size ten (208px)<code>$size-10</code>
                    </p>
                    <div className="size-example size-10"></div>
                </div>
            </div>
        </>
    );
};
